import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router'

import { userActions } from './../../store/private/user';

class Login extends React.Component {

    constructor(props) {
        super(props);

        // reset login status
        if (localStorage.getItem('user')) {
            alert("You can't login if you are logged in!")
            props.history.push('/admin')
        }

        this.state = {
            username: '',
            password: '',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        const { username, password } = this.state;
        if (username && password) {
            this.props.login(username, password);
        } else {
            this.setState({ submitted: true });
        }
    }

    render() {

        const { username, password, submitted } = this.state;

        return (
            this.props.user ? <Redirect to="/admin" /> :
                <div className="login bg-black animated fadeInDown">
                    <div className="login-header">
                        <div className="brand">
                            <span className="logo"></span> <b>KARAedu</b> Admin <small>카라 동물권교육 홈페이지 관리자</small>
                        </div>
                        <div className="icon">
                            <i className="fa fa-lock"></i>
                        </div>
                    </div>
                    <div className="login-content">
                        <form onSubmit={this.handleSubmit} method="POST" className="margin-bottom-0">
                            <div className="form-group m-b-20">
                                <input name="username" value={username} onChange={this.handleChange} type="text" className="form-control form-control-lg inverse-mode" placeholder="Email Address" required />
                                {submitted && !username &&
                                    <div className="help-block">필수 항목입니다.</div>
                                }
                            </div>
                            <div className="form-group m-b-20">
                                <input name="password" value={password} onChange={this.handleChange} type="password" className="form-control form-control-lg inverse-mode" placeholder="Password" required />
                                {submitted && !password &&
                                    <div className="help-block">필수 항목입니다.</div>
                                }
                            </div>
                            <div className="checkbox checkbox-css m-b-20">
                                <input type="checkbox" id="remember_checkbox" />
                                <label htmlFor="remember_checkbox">로그인 유지</label>
                            </div>
                            <div className="login-buttons">
                                <button type="submit" className="btn btn-success btn-block btn-lg">로그인</button>
                            </div>
                        </form>
                    </div>
                </div>
        )
    }
}

export default connect(
    state => state.user,
    dispatch => bindActionCreators({ ...userActions }, dispatch)
)(Login);


// WEBPACK FOOTER //
// ./src/pages/private/login.js